import type {ReactElement} from 'react';
import React from 'react';
import {BaseFillTypeOptions} from '@Panels/poster-editor-text-fill-panel/components/base-fill-type-options';
import {BaseFillColorOptions} from '@Panels/poster-editor-text-fill-panel/components/base-fill-color-options';
import type {FillObject, FillTypes} from '@PosterWhiteboard/classes/fill.class';

interface BaseFillOptionsProps {
  fillObject: FillObject;
  onOpenColorPanel(colorIndex: number): void;
  panelId: string;
  onChangeFillType(newType: FillTypes): void;
  allowPanelHeightToBeSetInternally?: boolean;
}

export function BaseFillOptions({allowPanelHeightToBeSetInternally = true, ...props}: BaseFillOptionsProps): ReactElement | null {
  const getColorFillOption = (): ReactElement => {
    return (
      <BaseFillColorOptions
        fillObject={props.fillObject}
        onOpenColorPanel={(index): void => {
          props.onOpenColorPanel(index);
        }}
      />
    );
  };

  const getFillTypeOptions = (): ReactElement => {
    return (
      <BaseFillTypeOptions
        allowPanelHeightToBeSetInternally={allowPanelHeightToBeSetInternally}
        panelId={props.panelId}
        fillObject={props.fillObject}
        onChangeFillType={(newType): void => {
          props.onChangeFillType(newType);
        }}
      />
    );
  };

  return (
    <>
      {getColorFillOption()}
      {getFillTypeOptions()}
    </>
  );
}
